import React, { useState } from 'react';
import Button from '../Form/Button/Button'
import { gql } from "apollo-boost";
import { useMutation } from "@apollo/react-hooks";
import withFeatureFlags from '../FeatureFlags/withFeatureFlags';
import MaturityInstructionOtpModal from "./MaturityInstructionOtpModal";
import "../SharedComponents/button-styles.scss";
import {useLogger} from "../../contexts/Logger";
import {useUnifiedAnalytics} from "../../contexts/AnalyticsWrapper";

/** @import {ConfirmInstructionButtonProps} from './ConfirmInstructionButtonTypes' */
/** @import {WithFeatureFlagsProps} from '../FeatureFlags/FeatureFlagsTypes' */

const SEND_OTP = gql`
  mutation SendLoggedInOtp($request : SendOtpRequestType!){
    sendLoggedInOtp(request:$request) {
      success
      verificationToken
    }
  }  
`;

function ConfirmInstructionButton(/** @type {ConfirmInstructionButtonProps & WithFeatureFlagsProps} */ {
    disabled,
    instruction,
    label,
    mobileNumber,
    account,
    destinationAccount,
    multipleMaturingAccounts,
    customClassName,
    onOTPSuccess,
    customAnalytics,
    showConfirmationOnSuccess
}) {
    const logger = useLogger();
    const [sendOtp] = useMutation(SEND_OTP);
    const [showOtpModal, setShowOtpModal] = useState(false);
    const [verificationToken, setVerificationToken] = useState('');

    const analytics = useUnifiedAnalytics();

    const prepareOtpModal = async () => {
        // const getActionType = () => {
        //     if (!instruction) {
        //         return 'transfer everything-linked';
        //     }
        //    
        //     const instrName = typeof instruction === 'string' ? instruction : instruction.name;
        //
        //     if (instrName === 'RolloverAllFunds') {
        //         return 'renew everything';
        //     } else if (instrName === 'RolloverPartialFundPayoutInterest') {
        //         return `renew partial-${instruction?.options?.selectedTransferAccount?.product?.name || 'linked account'}`;
        //     } else {
        //         return `transfer everything-${destinationAccount?.product.code || 'linked'}`;
        //     }
        // };
        // analytics.trackAnalyticsClickTransactionEvent(
        //     'confirm',
        //     account?.product?.code.split('_')[0] || '',
        //     getActionType(),
        //     getActionType(),
        //     "maturity-instruction|click|confirm-instruction",
        //     'maturity',
        //     account?.product?.code
        // );

        // analytics.trackAnalyticsPopupEvent(
        //     "confirm your instruction",
        //     "otp",
        //     "maturity",
        //     "maturity-instruction|roadblock_load|confirm your instruction",
        //     "maturity_confirm your instruction"
        // );


        if (customAnalytics){
            customAnalytics()
        } else {
            analytics.trackAnalyticsClickEvent(
                "give my instruction",
                window.location.pathname,
                "component left",
                "fixed rate saver",
                "maturity",
                {},
                "link click",
                "instruction|give|maturity",
                "fixed rate saver"
            );

        }

        try {
            setShowOtpModal(true);
            await generateOtp();
        }
        catch (e) {
            logger.info(`Error sending maturity instruction OTP: ${e instanceof Error ? e.message : "UNKNOWN"}`);
        }
    }
    const generateOtp = async () => {

        logger.info('Sending maturity instruction OTP');

        const result = await sendOtp({
            variables: {
                request: {}
            }
        });

        if (result.data.sendLoggedInOtp.verificationToken) {
            logger.info('Maturity instruction OTP successfully sent');
            setVerificationToken(result.data.sendLoggedInOtp.verificationToken);
        }
        else {
            logger.info('Maturity instruction OTP failed to send');
        }
    }
    return (
        <>
            <Button size='med'
                    customClassNames={customClassName ? [customClassName] : undefined}
                    label={label ? label : "Confirm my instruction"}
                    onClick={() => prepareOtpModal()}
                    disabled={disabled} />
            <MaturityInstructionOtpModal
                showModal={showOtpModal}
                onClose={() => setShowOtpModal(false)}
                onOTPSuccess={onOTPSuccess}
                mobileNumber={mobileNumber}
                account={account}
                instruction={instruction}
                destinationAccountId={destinationAccount && typeof destinationAccount !== 'string' ? destinationAccount.id : null}
                verificationToken={verificationToken}
                showConfirmationOnSuccess={showConfirmationOnSuccess}
                multipleMaturingAccounts={multipleMaturingAccounts}/>
        </>
    )
};

export default withFeatureFlags(ConfirmInstructionButton);
